import { createRequiredContext } from '@/utils/create-required-context'

type NavbarContext = {
    isDrawerOpen: boolean
    setIsDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const [NavbarContextProvider, useNavbarContext] =
    createRequiredContext<NavbarContext>('NavbarContext')
